<template>
    <div>
        <button v-if="msp.currentViewStatus === 'grid-view'" type="button" @click="onChangeViewStatus('map-view')" class="hidden-xs">
          <i class="icon-map"></i> <span>{{ molang('search.view.map') }}</span>
        </button>
        <button v-if="msp.currentViewStatus === 'map-view'" type="button" @click="onChangeViewStatus('grid-view')" class="hidden-xs">
          <i class="icon-list"></i>
          <span>{{molang('search.common.list')}}</span>
        </button>
    </div>
</template>
<script src="./search-switchview.js"></script>
<style lang="scss">
    @use "./search-switchview.scss" as *;
</style>